<template>
  <div class="md-layout-item title-bread md-size-100">
    <div>
      <div class="md-group pull-left title">
        AgBi - Región:&nbsp;
      </div>
      <div class="md-group pull-left">
        <drop-down direction="down">
          <md-button slot="title" class="md-button md-info md-sm dropdown-toggle" data-toggle="dropdown">
            {{ regionSelected }}
          </md-button>
          <ul class="dropdown-menu dropdown-menu-left">
            <li v-for="region in regions" :key="region"><a @click="changeSelectedRegion(region)">{{region}}</a></li>
          </ul>
        </drop-down>
      </div>
      <div class="md-group pull-left" style="margin-left:5px;">
        <drop-down direction="down">
          <md-button slot="title" class="md-button md-success md-sm dropdown-toggle" data-toggle="dropdown">
            <svg-icon v-if="icons[cropKey(cropSelected)]" type="mdi" :path="icons[cropKey(cropSelected)]" class="crop-icon" /> {{ cropSelected }}
          </md-button>
          <ul class="dropdown-menu dropdown-menu-left">
            <li v-for="crop in crops" :key="crop">
              <a @click="changeSelectedCrop(crop)">
                <svg-icon
                v-if="icons[cropKey(crop)]"
                type="mdi"
                :path="icons[cropKey(crop)]"
                class="crop-icon"
                />
                {{ crop }}
              </a>
            </li>
          </ul>
        </drop-down>
      </div>
      <info-icon :message="info[2]"></info-icon>
    </div>
    <div class="pull-right">
      <label-az-group />
    </div>
  </div>
</template>

<script>
import InfoIcon from "../InfoIcon";
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiSprout, mdiCorn, mdiBarley, mdiSpa, mdiFlowerOutline } from '@mdi/js'
import LabelAzGroup from '@/components/LabelAzGroup.vue'

export default {
  name: "crops-menu",
  components: {InfoIcon, SvgIcon, LabelAzGroup  },
  props: ['regions', 'crops', 'regionSelected', 'cropSelected', 'InfoIcon', 'info'],

  methods: {
    changeSelectedRegion(region) {
      this.$emit('update-selected-region', region);
    },
    changeSelectedCrop(crop) {
      this.$emit('update-selected-crop', crop);
    },
    cropKey(crop) {
      if (!crop) return '';

      // Pasamos a string, minúsculas, sin espacios al inicio/fin
      let key = crop.toString().toLowerCase().trim();

      // Eliminamos acentos/diacríticos para que "maíz" matchee con "maiz"
      key = key.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      // Tomamos solo la primera "palabra" antes de guiones, espacios u otros separadores:
      // "trigo-soja" => "trigo", "cebada soja" => "cebada"
      const parts = key.split(/[^a-z]/).filter(Boolean);
      if (parts.length > 0) {
        key = parts[0];
      }

      return key;
    },
  },
  data(){
    return{
      icons: {
        trigo: mdiBarley,
        maiz: mdiCorn,
        soja: mdiSprout,
        cebada: mdiSpa,
        girasol: mdiFlowerOutline,
      }
    }
  }
}
</script>

<style scoped>
  #crops-section > .title-bread {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  .title-bread{
    background-color: #ddd ;
    border-radius: 4px;
    padding: 1px 5px;
    font-weight: bold;
    color:#667
  }
  .title-bread .title{
    margin-top:6px;
    display: inline-block;
  }
  .title-bread .crop{
    color: green;
  }
  .title-bread .crop .md-icon{
    color: green;
    font-size:18px !important;
    vertical-align: top;
    margin-top:-1px;
  }
  .crop-icon {
    width: 18px;
    height: 18px;
    margin-right: 6px;
    vertical-align: middle;
  }
</style>
